<template>
  <kd-layout-fixed-bottom-button class="gift-detail-page">
    <div class="main" v-if="giftDetail">
      <div class="header">
        <img class="gift" :src="giftDetail.img_url" :width="$px(80)" :height="$px(80)" />
        <div class="info">
          <div class="name">{{ giftDetail.name }}</div>
          <!-- <div class="activity">{{ giftDetail.activity === 'summer_2023' ? '暑假2023' : giftDetail.activity }}</div> -->
        </div>
      </div>

      <div class="detail">
        <div class="item" v-for="(item, index) in detailItems" :key="index">
          <div class="label">{{ item.label }}：</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <template #footer>
      <kd-button class="change-address" v-if="canChangeAddress" @click="navToChangeAddressPage">{{
        orderLabel
      }}</kd-button>

      <kd-button class="copy-btn" v-else @click="copyTrackingNumber">复制快递单号</kd-button>
    </template>
  </kd-layout-fixed-bottom-button>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { KdLayoutFixedBottomButton, KdButton } from 'kuaidong-ui'
import { HtmlUtil } from 'kuaidong-lib'
import { GiftOrderStatus, IGiftOrderDetail } from 'kuaidong-model'
import { AGiftOrder } from 'kuaidong-api/src/AGiftOrder'
import { GiftOrderService } from 'kuaidong-service/src/GiftOrderService'
@Component({
  components: {
    KdButton,
    KdLayoutFixedBottomButton,
  },
})
export default class GiftDetailPage extends BasePage {
  @Prop({ type: String, required: true })
  giftOrderId!: string

  get canChangeAddress() {
    return this.giftDetail && (!this.giftDetail.tracking_no || this.giftDetail.status !== GiftOrderStatus.HasShipped)
  }

  get service() {
    return GiftOrderService
  }

  get detailItems() {
    return [
      {
        label: '获得时间',
        value: this.giftDetail ? this.service.formatOrderDateTime(this.giftDetail.get_gift_time) : '-',
      },

      {
        label: '收件人',
        value: this.giftDetail?.receiver || '-',
      },

      {
        label: '手机号码',
        value: this.giftDetail ? this.formatPhone(this.giftDetail.phone) : '-',
      },

      {
        label: '所在地区',
        value: this.giftDetail ? this.service.formatGiftRegion(this.giftDetail) : '-',
      },

      {
        label: '详细地址',
        value: this.giftDetail?.address || '-',
      },

      {
        label: '快递公司',
        value: this.giftDetail?.tracking_company_name || '-',
      },

      {
        label: '快递单号',
        value: this.giftDetail?.tracking_no || '-',
      },
    ]
  }

  get isHaveAddress() {
    return this.giftDetail && this.giftDetail.address
  }

  get orderLabel() {
    if (this.isHaveAddress) {
      return '修改收货地址'
    } else {
      return '添加收货地址'
    }
  }
  giftDetail: IGiftOrderDetail | null = null

  async created() {
    this.fetcherOrderDetail()
  }

  async fetcherOrderDetail() {
    this.giftDetail = await AGiftOrder.orderDetail(this.giftOrderId)
  }

  async copyTrackingNumber() {
    if (await HtmlUtil.copyToClipboard(this.giftDetail!.tracking_no)) {
      this.toast('快递单号复制成功~')
    } else {
      this.toast('快递单号复制失败~')
    }
  }

  formatPhone(phone: string | null) {
    return phone ? phone.slice(0, 3) + '****' + phone.slice(7, 11) : '-'
  }

  navToChangeAddressPage() {
    this.$router.push({
      name: 'select_my_gift_address',
      query: {
        addressInfo: JSON.stringify(this.giftDetail),
      },
    })
  }
}
</script>
<style lang="less">
.kd-layout-fixed-bottom-button.gift-detail-page {
  > .kd-layout-fixed-bottom__main {
    padding: 16px;
    > .main {
      background: #ffffff;
      border-radius: 8px;
      padding: 20px 16px 26px;
      > .header {
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #f5f5f5;
        > .gift {
          margin-right: 11px;
        }
        > .info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          > .name {
            font-weight: 500;
            font-size: 14px;
            line-height: 150%;
            color: #2d2f33;
            text-align: left;
          }
          > .activity {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #8f8f8f;
          }
        }
      }

      > .detail {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        > .item {
          display: flex;
          margin-bottom: 18px;
          text-align: left;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          > .label {
            color: #8f8f8f;
            margin-right: 8px;
            flex: none;
            text-align: right;
          }
          > .value {
            color: #2d2f33;
            width: 227px;
          }
        }
      }
    }
  }

  > .kd-layout-fixed-bottom__footer {
    > .change-address {
      border: 1px solid #3366ff;
      border-radius: 8px;
      font-weight: 500;
      font-size: 16px;
      line-height: 16px;
      text-align: center;
      letter-spacing: 1px;
      color: #3366ff;
      background: #fff;
    }
  }
}
</style>
